import { types, applySnapshot } from 'mobx-state-tree';
import { makeRequest } from 'js/services/Network';
import analytics from 'js/services/Analytics';
import EmailPreference from '../types/EmailPreference';

export default types
  .model('EmailPreferencesPage', {
    isSaving: false,
    wasSaved: false,
    preferences: types.optional(types.array(EmailPreference), []),
    error: types.maybeNull(types.string),
  })
  .actions(self => ({
    load() {
      return makeRequest('email-preferences-data').then(self.applyLoadResponse);
    },
    applyLoadResponse(response) {
      applySnapshot(self.preferences, response.data);
    },

    save(event, formValues) {
      if (!self.isSaving) {
        self.isSaving = true;
        self.error = null;
        makeRequest('email-preferences-save', null, formValues)
          .then(self.saveSuccess)
          .then(() => {
            //analytics.track('saved email preferences')
          })
          .catch(self.saveError);
      }
    },
    saveSuccess() {
      self.isSaving = false;
      self.wasSaved = true;
    },
    saveError(error) {
      self.isSaving = false;
      self.error = error.response.data.message || error.response.statusText;
    },
  }));
